import { SessionDetail } from '../../../models/profit/profit.model';
import { useGet } from '../../useApi';

// GET /admin/sessions/{id}
const useSessionDetail = () => {
  const { data, loading, fetch } = useGet<SessionDetail>('Failed to load the session');
  return { session: data, loading, fetchSession: (id: string) => fetch(`api/v1/admin/sessions/${id}`) };
};

export default useSessionDetail;
